// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9edf84c1","803":"01ce5258","818":"d99470d3"}[chunkId] + ".chunk.js";
};